import { CanActivateFn, Router } from '@angular/router';
import { UserAuthService } from './UserAuth.service';
import { inject } from '@angular/core';

export const userAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(UserAuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  const roles = authService.getRoles();
  const needsCustomerSelection =
    roles.includes('SuperAdmin') || roles.includes('administrator');

  if (needsCustomerSelection && !authService.getActiveCustomer()) {
    router.navigate(['/select-customer']);
    return false;
  }

  return true;
};
